// edit by ling 2018.12.18
// 路由懒加载: https://router.vuejs.org/zh/guide/advanced/lazy-loading.html
const AppLayout = () => import('@/components/AppLayout')
const LoginPage = () => import('@/page/login')
const DashboardPage = () => import('@/page/dashboard')
const SettingsPage = () => import('@/page/settings')

export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },

  {
    // has been logged in
    path: '/web',
    name: 'web',
    component: AppLayout,
    redirect: '/web/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashboardPage,
        meta: { keepAlive: true }
      },
      {
        path: 'settings',
        name: 'settings',
        component: SettingsPage
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js